import { Injectable, ComponentFactoryResolver, Injector, ViewContainerRef, ComponentRef } from "@angular/core";
import { EntityRowRenderer } from "../../../core/services/entity-link/entity-row-renderer.service";
import { TaskRowV2Component } from "./task-row-v2.component";
import { Task } from 'src/app/rent-module/shared/entities/task/task';
@Injectable()
export class TaskRowV2Renderer extends EntityRowRenderer {
  
  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private injector: Injector
  ) {
    super();
  }

  canRender(entityType: string): boolean {
    return entityType === 'Task';
  }

  render(entity: any, container: ViewContainerRef, injector?: Injector): ComponentRef<any> {
    const factory = this.componentFactoryResolver.resolveComponentFactory(TaskRowV2Component);
    const componentRef = container.createComponent(factory, undefined, injector ?? this.injector);
    
    // Set the input property using setInput for signal-based inputs
    componentRef.setInput('task', new Task(entity));
    componentRef.setInput('showMetadata', true);
    
    return componentRef;
  }
}